module.exports = __webpack_public_path__ + "img/waku_null.9cc0db5c.png";